import style from "./codeBox.module.css";

import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { oneDark as codeStyle } from "react-syntax-highlighter/dist/esm/styles/prism";
import CopyBlock from "../../../../../../../../../../../Common/CopyBlock/CopyBlock";

interface Props {
  code: string;
  separator: boolean;

  language: string;
}

const customStyle = {
  textAlign: "left" as const,
  fontSize: 17,
  fontFamily: "Arial",
  backgroundColor: "rgba(0,0,0,0)",
  margin: "0px 0px 0px 10px",
  padding: "5px 0px",
  borderRadius: "0",
};

function CodeBox({ code, separator, language }: Readonly<Props>) {
  const separatorClass = separator ? style.separatorDown : style.separatorUp;

  function getDivs() {
    return (
      <CopyBlock
        text={code}
        content={
          <div className={style.divWrapper}>
            <SyntaxHighlighter
              language={language}
              showLineNumbers
              lineProps={{
                style: {
                  wordBreak: "break-word",
                  whiteSpace: "pre-wrap",
                  paddingLeft: "3.5em" /* Adjust this value as needed */,
                  textIndent: "-3.5em",
                  display: "block" /* Ensure each line is a block element */,
                },
              }}
              lineNumberStyle={{
                minWidth: "2em", // Ensure space for line numbers
                textAlign: "right", // Right align line numbers
                paddingRight: "0.5em", // Space between line numbers and code
              }}
              wrapLines
              style={codeStyle}
              customStyle={customStyle}
              className={style.divWrapper + " " + separatorClass}
            >
              {code}
            </SyntaxHighlighter>
          </div>
        }
      />
    );
  }

  return <>{getDivs()}</>;
}

export default CodeBox;
